<div id="map-container">
  @if (enableQuickLatLongSearch) {
  <!-- Latitude and Longitude Input Fields -->
  <div class="d-flex align-items-center w-100 flex-wrap gap-2 mb-2">
    <input type="number" class="form-control w-auto h-quick-access" [(ngModel)]="latitudeInput"
      placeholder="Enter Latitude" [ngClass]="{'invalid-input': !isLatitudeValid() && latitudeInput !== null}"
      (input)="onInputChange()" min="-90" max="90" step="any" />
    <input type="number" class="form-control w-auto h-quick-access" [(ngModel)]="longitudeInput"
      placeholder="Enter Longitude" [ngClass]="{'invalid-input': !isLongitudeValid() && longitudeInput !== null}"
      (input)="onInputChange()" min="-180" max="180" step="any" />
    <button class="btn w-auto btn-go h-quick-access" (click)="onSubmitLocation()" [disabled]="!isFormValid()"
      [ngClass]="{'disabled-button': !isFormValid()}">
      GO
    </button>
  </div>
  }

  <div class="map-container">
    <!-- Google Map Container -->
    <div #mapContainer id="map" style="width: 100%; height: 288px;" aria-labelledby="mapTitle" aria-hidden="false">
    </div>

    <!-- Marker -->
    <img src="assets/images/icons/pin.svg" class="marker position-absolute" alt="marker">
  </div>
</div>
